import { useFormik } from 'formik';
import AuthWrapper from 'shared/components/auth_wrapper/AuthWrapper';
import { ForgotVS } from 'shared/utils/validation/AuthValidation';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import CustomInput from 'shared/components/common/custom_input/CustomInput';
import styles from './style.module.scss';
import { classNames } from 'shared/utils/Helper';
import Heading from 'shared/components/common/heading/Heading';
import { forgotImage, BackIcon } from 'assets';
import { useNavigate } from 'react-router-dom';
import { routeConstant } from 'shared/routes/RouteConstant';
import { ForgotUserMutation } from 'shared/services/auth_service/AuthService';

const Forgot = () => {
    const navigate = useNavigate();
    const { mutate, isLoading, isError, isSuccess, error, data } = ForgotUserMutation();
    const initialValues = {
        email: ''
    };
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: ForgotVS,
        onSubmit: (value) => {
            forogtHandler(value);
        }
    });
    const { handleChange, handleSubmit, values, touched, errors } = formik;

    const forogtHandler = (values, action) => {
        mutate(values)
        // navigate(routeConstant.otp.path);
    };
    const handleNavigate = () => {
        navigate(routeConstant.login.path);
    };

    return (
        <AuthWrapper mainImage={forgotImage} heading="“ Use Wise Tech to manage and collaborate in a smoother and more efficient way. ”">
            <div className={classNames(styles.ForgotContainer)}>
                <Heading heading="Forgot Password" headingStyle={classNames(styles.ForgotHeading)} />
                <div className={classNames(styles.ForgotMainTitle)}>Please enter the email address associated with your account</div>
                <CustomInput label="Email" placeholder="e.g, john.legend@gmail.com" value={values.email} onChange={handleChange('email')} error={errors.email && touched.email ? errors.email : ''} />

                <CustomButton text="Send OTP" containerStyle={styles.ButtonContainer} submitHandle={handleSubmit} />
                <CustomButton Icon={BackIcon} text="Back to Login" containerStyle={styles.BackButton} IconStyle={styles.Icon} submitHandle={handleNavigate} />
            </div>
        </AuthWrapper>
    );
};

export default Forgot;
